import { connect } from "react-redux";

import { actions as analyticsActions } from "../analytics";
import { actions as compareActions } from "./Compare.redux";
import CompareDrawer from "./Compare.view";

const mapStateToProps = state => ({
  authenticated: !!state.login.auth.expires,
  comparedListings: state.comparedListings,
  targetDevice: state.targetDevice,
});

const mapDispatchToProps = dispatch => ({
  addDataLayerListingParameters: listings =>
    dispatch(analyticsActions.addDataLayerListingParameters(listings)),
  removeFromComparedListings: equipmentId =>
    dispatch(compareActions.remove(equipmentId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CompareDrawer);
